<div class="top-wr">
    <ozm-header></ozm-header>
</div>

<ag-grid-angular #agGrid 
    style="height: 500px" class="ag-theme-balham"
    (selectionChanged)="onSelectionChanged($event)"
    (gridReady)="onGridReady($event)"
    [rowData]="applis" 
    [columnDefs]="columnDefs"
    >
</ag-grid-angular>
<!-- <div>Row Count: {{rowCount()}}</div> -->
<a class="btn btn-primary mx-3 px-3" routerLink='/appli-detail'>
    <span class="nav-text">Add</span>
</a>
<a *ngIf="selected" class="btn btn-primary mx-3 px-3" (click)="viewDetail()">
    <span class="nav-text">View</span>
</a>
<div *ngIf="selectedRow">
    {{selectedRow._id | json}}
</div>

<!-- (selectionChanged)="onSelectionChanged($event)"
    (gridReady)="onGridReady($event)" [enableSorting]="true" 
    [enableFilter]="true" 
    [enableColResize]="true" [rowSelection]="'single'" -->
